import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { GraduationCap } from 'lucide-react'
import logo from '../assets/img/olan-academic-blanco.png'

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true)
  const containerRef = useRef(null)
  const logoRef = useRef(null)
  const barRef = useRef(null)
  const textRef = useRef(null)
  const barFillRef = useRef(null)

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        gsap.to(containerRef.current, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.in',
          onComplete: () => setIsLoading(false),
        })
      },
    })

    tl.fromTo(
      logoRef.current,
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 0.5, ease: 'power2.out' }
    )
    .fromTo(
      [barRef.current, textRef.current],
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' },
      '-=0.2'
    )
    .fromTo(
      barFillRef.current,
      { width: '0%' },
      { width: '100%', duration: 1.5, ease: 'power1.inOut' },
      '-=0.1'
    )

    return () => {
      tl.kill()
    }
  }, [])

  if (!isLoading) return null

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #0F293E 0%, #1a3a52 100%)',
      }}
    >
      <div ref={logoRef} className="flex flex-col items-center gap-4">
        {/* <div
          className="flex items-center justify-center rounded-full"
          style={{
            width: 80,
            height: 80,
            backgroundColor: '#10B981',
          }}
        >
          <GraduationCap size={40} color="white" strokeWidth={2.5} />
        </div> */}
        <span
          className="text-white font-bold text-2xl tracking-tight"
          style={{ letterSpacing: '0.05em' }}
        >
          <img src={logo} alt="Olan Academic" className="w-auto h-20" />
        </span>
      </div>

      <div ref={barRef} className="mt-8 w-[180px]" style={{ height: 4, borderRadius: 9999, backgroundColor: 'rgba(255,255,255,0.15)' }}>
        <div
          ref={barFillRef}
          style={{ height: '100%', borderRadius: 9999, backgroundColor: '#10B981' }}
        />
      </div>

      <p ref={textRef} className="mt-4 text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
        Cargando propuesta comercial...
      </p>
    </div>
  )
}

export default Preloader
